import { Customer, CustomerFilter, CustomerSummary, NewCustomer, UpdatedCustomer } from './customer.types';
import { Injectable } from '@angular/core';
import { PagedList } from '../common/common.types';
import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CustomerService {
	private readonly customersUrl = 'api/customers';
	private readonly customerUrl = (customerId: number) => `api/customers/${customerId}`;

	constructor(private _http: Http, private http: HttpClient) { }

	getCustomers(customerFilter?: CustomerFilter): Promise<PagedList<CustomerSummary>> {
		return this._http.get(this.customersUrl, { params: customerFilter })
			.toPromise()
			.then(response => response.json() as PagedList<CustomerSummary>);
	}

	getMe(): Promise<Customer> {
		return this.http.get<Customer>(this.customersUrl + '/me').toPromise();
	}

	getCustomer(customerId: number): Promise<Customer> {
		return this.http.get<Customer>(this.customerUrl(customerId)).toPromise();
	}

	createCustomer(newCustomer: NewCustomer): Promise<number> {
		return this.http.post<number>(this.customersUrl, newCustomer).toPromise();
	}

	updateCustomer(customerId: number, updatedCustomer: UpdatedCustomer): Promise<void> {
		return this.http.put<void>(this.customerUrl(customerId), updatedCustomer).toPromise();
	}

	consolidateCustomers(customerId: number, duplicateCustomerIds: number[]): Promise<void> {
		return this.http.put<void>(`${this.customerUrl(customerId)}/consolidate`, duplicateCustomerIds).toPromise();
	}
}
